import { config } from "../config";

const getSubAdmin = async (userId) => {
    if (!userId) return console.warn("No UID found for fetching admin data");

    try {
        const response = await fetch(`${config.backEndBaseUrl}sub-admin/read/${userId}`, {
            method: "GET",
            headers: {
                "x-dashboard-request": "true",
            },
        });
        const result = await response.json();

        if (response.ok && result.status && result.sub_admin) {
            return result.sub_admin.permissions;
        } else {
            console.warn("Failed to fetch admin data:", result.message);
            return null;
        }
    } catch (error) {
        console.error("Error fetching admin data:", error);
        return null;
    }
};
export default getSubAdmin;